import { render } from "./settingsPeriodSystemView.vue?vue&type=template&id=475229f0"
import script from "./settingsPeriodSystemView.vue?vue&type=script&lang=js"
export * from "./settingsPeriodSystemView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__